/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';

import { getApiEndpoints } from 'environments/api-endpoints';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private _endpoints;

  constructor() {
    this._endpoints = getApiEndpoints();
  }

  refresh(): void {
    this._endpoints = getApiEndpoints();
  }

  get coreApi(): string {
    return `${this._endpoints.CORE_API}`;
  }

  get superAdminApi(): string {
    return `${this._endpoints.SUPER_ADMIN_API}`;
  }

  get coreApiSuperAdmin(): string {
    return `${this._endpoints.CORE_API_SUPER_ADMIN}`;
  }

  get esAPI(): string {
    return `${this._endpoints.ES_API}`;
  }

  get clusters(): string {
    return `${this._endpoints.API_ENDPOINT__CLUSTERS}`;
  }

  get storageApi(): string {
    return `${this._endpoints.STORAGE_API}`;
  }

  get contractAiApi(): string {
    return `${this._endpoints.CONTRACT_AI_API}`;
  }

  get calls(): string {
    return `${this._endpoints.API_ENDPOINT__CALLS}`;
  }

  get companies(): string {
    return `${this._endpoints.API_ENDPOINT__COMPANIES}`;
  }

  get companyUsers(): string {
    return `${this._endpoints.API_ENDPOINT__USERS_OF_COMPANY}`;
  }

  get defaultCommisionRate(): string {
    return `${this._endpoints.API_ENDPOINT__DEFAULT__COMMISSION__RATE}`;
  }

  get documents(): string {
    return `${this._endpoints.API_ENDPOINT_DOCUMENTS}`;
  }

  get forgotPassword(): string {
    return `${this._endpoints.API_ENDPOINT__FORGOT_PASSWORD}`;
  }

  get login(): string {
    return `${this._endpoints.API_ENDPOINT__AUTHENTICATE}`;
  }

  get payments(): string {
    return `${this._endpoints.API_ENDPOINT__PAYMENTS}`;
  }

  get utils(): string {
    return `${this._endpoints.API_ENDPOINT__UTILS}`;
  }

  get users(): string {
    return `${this._endpoints.API_ENDPOINT__USERS}`;
  }

  get userPermission(): string {
    return `${this._endpoints.API_ENDPOINT__USER_PERMISSION}`;
  }

  get userPermissionGroups(): string {
    return `${this._endpoints.API_ENDPOINT__USER_PERMISSION_GROUPS}`;
  }

  /* Booked shipments for client reports */
  get bookedShipmentsForClientReports(): string {
    return `${this._endpoints.API_ENDPOINT__BOOKED_SHIPMENTS_FOR_CLIENT}`;
  }

  get quickbooks(): string {
    return `${this._endpoints.API_ENDPOINT__QUICKBOOKS}`;
  }

  get geocode(): string {
    return `${this._endpoints.API_ENDPOINT__MAPS_GEOCODE}`;
  }
}
